import React from "react";
import {Modal} from "react-responsive-modal";
import s from './ErrorHandle.module.css';
// import exception from '../../img/exception.png'
import exception from '../../img/ErrorIcon.svg'
import {CopyToClipboard} from "react-copy-to-clipboard";

export const ErrorHandle = (props) => {
    const onClose = () => {
        props.showErrorPopup(false, '')
    };

    const modalStyles = {
        modal: {
            padding: '40px',
            borderRadius: '5px'
        },
        closeButton: {
            // top: '4px',
            right: '15px',
            top: '15px',
        },
        closeIcon: {
            width: '20px',
            height: '20px',
            // fill: 'black'
        }
    };

    return (
        <Modal open={props.data.isErrorPopupShow} onClose={onClose} center styles={modalStyles}>
            <div className={s.errorModalPopup}>
                <div className={s.errorIconAndCaptionWrapper}>
                    <div>
                        <img src={exception} alt="error"/>
                    </div>
                    <div className={s.errorCaptionWrapper}>
                        <div>Error</div>
                        <div className={s.errorCode}>
                            {props.data.errorBody.response.data.MessageID}
                        </div>
                    </div>
                </div>
                <div className={s.errorDescriptionWrapper}>
                    <div className={s.errorDescription}>
                        <div className={`${s.reasonErrorWrap} ${s.textContentInDescription}`}>
                            {props.data.errorBody.response.data.UserFriendlyMessage}
                        </div>
                        <div className={s.textContentInDescription}>
                            {props.data.errorBody.response.data.RecommendedAction}
                        </div>
                    </div>
                </div>
                <div className={s.errorButtonWrapper}>
                    <CopyToClipboard text={JSON.stringify(props.data.errorBody.response.data)}>
                        <button type="button" className={s.copyToClipboardBtn}>Copy to clipboard</button>
                    </CopyToClipboard>
                </div>
            </div>
        </Modal>
    )
};